import React from 'react';
import s from './Input.module.css';

export const MAX_FIELD_ROWS = 6;

export function resizeTextareaElement(textarea, maxRows = MAX_FIELD_ROWS, minRows = 1) {
  if (!textarea || textarea.tagName !== 'TEXTAREA') return;

  const style = window.getComputedStyle(textarea);
  const lineHeightStr = style.lineHeight;
  const parsedLineHeight = Number.parseFloat(lineHeightStr);
  const fontSize = Number.parseFloat(style.fontSize);
  let resolvedLineHeight = 22;
  if (Number.isFinite(parsedLineHeight) && parsedLineHeight > 0) {
    const lh = lineHeightStr?.trim?.() || '';
    const looksLikePx = lh.endsWith('px') || lh.includes('px');
    resolvedLineHeight = looksLikePx
      ? parsedLineHeight
      : Number.isFinite(fontSize) && fontSize > 0
        ? parsedLineHeight * fontSize
        : parsedLineHeight;
  }
  const paddingTop = Number.parseFloat(style.paddingTop) || 0;
  const paddingBottom = Number.parseFloat(style.paddingBottom) || 0;
  const borderTop = Number.parseFloat(style.borderTopWidth) || 0;
  const borderBottom = Number.parseFloat(style.borderBottomWidth) || 0;
  const verticalExtras = paddingTop + paddingBottom + borderTop + borderBottom;
  const minHeight = resolvedLineHeight * minRows + verticalExtras;
  const maxHeight = resolvedLineHeight * maxRows + verticalExtras;

  textarea.style.overflowY = 'hidden';
  textarea.style.height = '0px';
  const scrollHeight = textarea.scrollHeight;
  const contentHeight = Math.max(minHeight, scrollHeight);
  const nextHeight = Math.min(contentHeight, maxHeight);
  textarea.style.height = `${nextHeight}px`;
  textarea.style.overflowY = contentHeight > maxHeight ? 'auto' : 'hidden';
}

export function Input({
  value,
  onChange,
  placeholder = '',
  ariaLabel,
  inputRef,
  type = 'text',
  className = '',
  hideClear = false,
  ...rest
}) {
  const innerRef = React.useRef(null);
  const ref = inputRef ?? innerRef;

  const handleChange = (e) => {
    if (typeof onChange === 'function') onChange(e);
  };

  const handleClear = () => {
    if (typeof onChange === 'function') {
      onChange({ target: { value: '' } });
    }
    try {
      ref.current?.focus();
    } catch {}
  };

  const hasValue = value != null && value !== '';
  const showClear = hasValue && !hideClear;

  return (
    <div className={`${s.box} ${className}`.trim()}>
      <input
        ref={ref}
        type={type}
        className={`${s.input} ${showClear ? s.inputWithClear : ''}`}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={handleChange}
        aria-label={ariaLabel}
        {...rest}
      />
      {showClear && (
        <button
          type="button"
          className={s.clearBtn}
          aria-label={ariaLabel ? `Очистить: ${ariaLabel}` : 'Очистить'}
          onClick={handleClear}
        >
          <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M21 1L11 11M11 11L1 21M11 11L1 1M11 11L21 21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
}
